import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CheckboxFilter, InputSearchFilter, DateSearch, RangeSearch, StaticSelect, customSlelect, Market } from 'src/app/interface/interfaces';
import { SportServicesService } from 'src/app/services/sport-service/sport-services.service';
import { PartnerServicesService } from 'src/app/services/partner-service/partner-services.service';
import { GoalManagementService } from 'src/app/services/goal-service/goal-management.service';
import { ExtraAction } from 'src/app/interface/filter.model';
import { FlagService } from 'src/app/services/flag/flag.service';
import { CalenderTranslationService } from 'src/app/services/calendar-translation/calendar-translation.service';
declare var $: any;
@Component({
  selector: 'app-filter2',
  templateUrl: './filter2.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent2 implements OnInit {
  @Input() checkboxes: Array<CheckboxFilter>;
  @Input() inputSearches: Array<InputSearchFilter>;
  @Input() searchDropDowns: Array<any>;
  @Input() dateSearches?: Array<DateSearch> = [];
  @Input() staticSelect?: Array<StaticSelect>;
  @Input() goalSelectData?: Array<any> = new Array(0);
  @Input() selectFilters?: Array<customSlelect>;
  @Input() seleteditem?: any =  null;
  @Input() data: Array<any>;
  @Input() dateRangeSearches: Array<RangeSearch>;
  @Input() searchdata: any;
  @Input() hideSearch: boolean = false;
  @Input() hiderefresh: boolean = false;
  @Input() extraActions?: ExtraAction[] = [];
  @Input() tableInstance?: any;
  @Input() languageFilter?: { options: Array<{code: string, name: string}>, value: string, label: string, action: string };

  // if present and set to true advanced searching is enabled
  @Input() moreFilter = false;
  @Input() goalSearch = false;

  @Input() add: any;
  @Output() searchNew = new EventEmitter();
  @Output() refreshNew = new EventEmitter();
  @Output() dataFiltered = new EventEmitter();
  @Output() newSelect = new EventEmitter();
  @Output() addNew = new EventEmitter();
  @Output() filterCheckbox = new EventEmitter();
  @Output() goalSelect = new EventEmitter();
  @Output() outcomeChange = new EventEmitter();
  @Output() sportChange = new EventEmitter();
  @Output() eventChange = new EventEmitter();
  @Output() onloadSpecifier = new EventEmitter();
  @Output() languageFilterChange = new EventEmitter<string>();
  goalData:any = [];
  selectOptions: any = [];
  advancedSearching = false;
  loading = false;
  currentIndex: any = 0;
  selectedVals: any = [];
  copySearchdata: any;
  dateRangeSearch: any = ["","validity_start", "validity_end"];
  dateRange: any = "";
  localfliterParams = {
    sport: {},
    event: {},
    category: {},
    groups: {},
    partner:{},
    product:{},
    productType:{},
    productGroup: {},
    market: {}

  };
  searchTimeout: NodeJS.Timer;
  refreshTimeout: NodeJS.Timer;

  constructor(private sportService: SportServicesService,
              private translate: TranslateService,
              private partnerService: PartnerServicesService,
              private goalService: GoalManagementService,
              private calendarI18nService: CalenderTranslationService,
              private flagService: FlagService
              ) { }

  ngOnInit() {
    this.copySearchdata = JSON.parse(JSON.stringify(this.searchdata));
    this.goalData = {}
    if(this.goalSearch && this.searchdata.dateRange) this.searchdata.dateRange = this.dateRange;
  }

  get calendarLocale(){
    return this.calendarI18nService.locale;
  }

  getGoalItem(item, index){
    this.currentIndex = index
    switch (item.name) {
      case 'goal_type':
        if(this.goalSelectData[index].options.length) return;
        this.loading = true
        this.sportService.loadGoalTypes({}).then(res =>{
          let goaltypes = this.sportService.goalTypes;
          this.goalSelectData[index].options = goaltypes? goaltypes.map((elm, index) => {
            // this.selectedVals[index] = this.selectOptions;
            return {
              name: elm.strPoolTypeCode,
              value: elm.lgPoolTypeId
            }
          }) : []
        }).finally(()=>{
          this.loading = false;
        })

        break;
      case 'goal_package':
        if(this.goalSelectData[index].options.length) return;
        this.loading = true
        this.sportService.loadGoalPackages({}).then(res =>{
          let goalPackages = res.data || [];
          this.goalSelectData[index].options = goalPackages? goalPackages.map((elm, index) => {
            // this.selectedVals[index] = this.selectOptions;
            return {
              name: elm.name,
              value: elm.id
            }
          }) : []
        }).finally(()=>{
          this.loading = false;
        });
        break;
      case 'goal_status':
        this.goalSelectData[index].options = [
          {name: 'valid', value: 'valid'},
          {name: 'non_valid', value: 'non_valid'},
          {name: 'cancelled', value: 'cancel'},
          {name: 'ml_status.process', value: 'process'},
        ]
        break;
      case 'goal_rapport_status':
        this.goalSelectData[index].options = [
          {name: 'enable_', value: 'enable'},
          {name: 'disabled_', value: 'disabled'},
          {name: 'ml_status.cloturer', value: 'cloturer'},
        ]
        break;

      default:
        break;
    }
  }

  changeGoalValue(select){
    this.searchdata[select.action] = select.value;
  }
  toggleMore() {
    this.advancedSearching = !this.advancedSearching;
    const self = this;
    if (this.advancedSearching) {
      setTimeout(() => {
        $('.checkbox').click(function() {
          const checkboxIndex = Number($(this).attr('id'));
          const checkbox = self.checkboxes[checkboxIndex];

          if(checkbox.action == ('is_enabled') || checkbox.action == ('is_disabled') || checkbox.action == ('is_blocked') || checkbox.action == ('is_suspended')){
            if ($(this).hasClass('positive')) {
              $(this).removeClass('positive');
              $(this).html('');
              self.searchdata[checkbox.action] = '';
            }
            else {
              $(this).addClass('positive');
              self.searchdata[checkbox.action] = true;
              $(this).html('<svg id="i-checkmark" viewBox="0 0 32 32" width="20" height="20" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="10.9375%"><path d="M2 20 L12 28 30 4" /></svg>');
            }
          }
          else{
            if ($(this).hasClass('positive')) {
              $(this).removeClass('positive');
              $(this).addClass('negative');
              self.searchdata[checkbox.action] = false;
              $(this).html('<svg id="i-close" viewBox="0 0 32 32" width="20" height="20" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="10.9375%"><path d="M2 30 L30 2 M30 30 L2 2" /></svg>');
            } else if ($(this).hasClass('negative')) {
              $(this).removeClass('negative');
              $(this).html('');
              self.searchdata[checkbox.action] = '';
            } else {
              $(this).addClass('positive');
              self.searchdata[checkbox.action] = true;
              $(this).html('<svg id="i-checkmark" viewBox="0 0 32 32" width="20" height="20" fill="none" stroke="currentcolor" stroke-linecap="round" stroke-linejoin="round" stroke-width="10.9375%"><path d="M2 20 L12 28 30 4" /></svg>');
            }
          }


        });
      }, 300);
    }
  }
  submit() {
    this.searchNew.emit(this.searchdata);
  }
  changeRangefilterCondition(dateSearch: DateSearch) {
    this.searchdata[dateSearch.action] = new Date(dateSearch.value).getTime();
   }

  refreshPage() {
    this.searchdata = JSON.parse(JSON.stringify(this.copySearchdata));
    if(this.goalSearch){
      this.refreshNew.emit(this.searchdata);
    }else{
      this.searchNew.emit(this.searchdata);
    }

    this.selectFilters = this.selectFilters.map(filter => {
      filter.isRefreshing = true;
      return filter;
    });

    this.refreshTimeout = setTimeout(() => {
      this.selectFilters = this.selectFilters.map(filter => {
        filter.isRefreshing = false;
        return filter;
      });
    }, 300)
  }

  checkboxChange(checkbox: CheckboxFilter) {
    // this.filterCheckbox.emit(checkbox);
    checkbox.value = !checkbox.value;
    if (checkbox.value) {
        this.searchdata[checkbox.action] = true;
    } else {
        this.searchdata[checkbox.action] = '';
    }
  }
  changeSelectValue(select: StaticSelect) {
    this.searchdata[select.action] = select.value;
    let index;
    if (select.label === 'transaction_type') {
      index = this.staticSelect.findIndex( el => {
        return el.label === 'bet_status' || el.label === 'provider';
      });
      if (index !== -1) {
        this.staticSelect.splice(index);
      }
      switch (select.value) {
        case 'R':
        case 'D':
          const providersOptions =  { placeholder : '', label: 'provider', action: 'subProvider', value: '',
          options: [{name: '', value: ''}]
          };
          this.staticSelect.push(providersOptions);
          this.populateSubProviders();
          break;
        case 'B':
          const betstatusOptions =   { placeholder : '', label: 'bet_status', action: 'betType', value: '',
          options: [
                    {name: '', value: ''},
                    {name: 'Payé', value: 'paid'},
                    {name: 'Mise', value: 'placed'},
                    {name: this.translate.instant('loss'), value: 'lost'},
                    {name: 'Annulé', value: 'cancel'},
                    {name: this.translate.instant('win'), value: 'won'}]
          };
          this.staticSelect.push(betstatusOptions);
          break;
        default:
          index = this.staticSelect.findIndex( el => {
            return el.label === 'bet_status' || el.label === 'provider';
          });
          if (index !== -1) {
            this.staticSelect.splice(index);
          }
      }
    }
  }
  changegoalValue(select:any){
    this.goalSelect.emit(select)
    // if (select.label === 'goal-type'){
    // }
  }
  populateSubProviders() {
    if (!this.sportService.subproviders.length) {
      this.sportService.loadsubProviders({}).then (_ => {
        const index = this.staticSelect.findIndex( el => {
          return el.label === 'provider';
        });
        if (index !== -1 && this.staticSelect[index].options.length < 2) {
          this.sportService.subproviders.forEach(subprovider => {
            this.staticSelect[index].options.push({name: subprovider.desc, value: subprovider.name});
          });
        }
      });
    } else {
      const index = this.staticSelect.findIndex( el => {
        return el.label === 'provider';
      });
      if (index !== -1 && this.staticSelect[index].options.length < 2) {
        this.sportService.subproviders.forEach(subprovider => {
          this.staticSelect[index].options.push({name: subprovider.desc, value: subprovider.name});
        });
      }
    }

  }

  changeSelectedItem(item, selectFilter: customSlelect) {
    if (item.hasOwnProperty(selectFilter.selectKey)) {
      this.searchdata[selectFilter.selectKey] = item[selectFilter.selectKey][selectFilter.itemKey];
    } else {
      this.searchdata[selectFilter.selectKey] = item[selectFilter.itemKey];
    }

    if (item.id.toString().includes('sr:sport')) {
      this.localfliterParams.sport = item;
      this.sportChange.emit(item);
      const params = {filter: '', page: 0, perpage: 20};
      const [el] = this.selectFilters.filter( el =>  el.type === 'category' );
      if ('name' in this.localfliterParams.sport) {
        params['sport'] = this.localfliterParams.sport['name'];
      }
      if (el) {
        el.loading = true;
        this.sportService.filterCategories(params).then(response => {
          el.data = this.sportService.categories.data;
          el.loading = false;
        });
      }
    } else if (item.id.toString().includes('sr:category')) {
      this.localfliterParams.category = item;
      const params = {filter: '', page: 0, perpage: 20};
      const [el] = this.selectFilters.filter( el => el.type === 'tournament' );
      if ('name' in this.localfliterParams.sport) {
        params['sport'] = this.localfliterParams.sport['name'];
      }
      if ('name' in this.localfliterParams.category) {
        params['category'] = this.localfliterParams.category['name'];
      }
      if (el) {
        el.loading = true;
        this.sportService.searchTournaments(params).then(response => {
          el.data = this.sportService.tournaments;
          el.loading = false;
        });
      }
    } else if (item.id.toString().includes('sr:match')){
      this.localfliterParams.event = item;
      this.eventChange.emit(item);
      const params = {filter: '', page: 0, perpage: 20};
      const [el] = this.selectFilters.filter( el => el.type === 'event' );
      if ('name' in this.localfliterParams.sport) {
        params['sport'] = this.localfliterParams.sport['name'];
      }
      if ('name' in this.localfliterParams.category) {
        params['category'] = this.localfliterParams.category['name'];
      }
      if (el) {
        el.loading = true;
        this.sportService.loadEvents(params).then(response => {
          el.data = this.sportService.sportEvents;
          el.loading = false;
        });
      }
    } else{
      switch (selectFilter.label) {
        case "market":
          this.handleMarketSelection(item, selectFilter)
          break;

        default:
          this.handleGroupsSelection(item, selectFilter)
          break;
      }

    }
  }
  handleMarketSelection(item, filterData: customSlelect){
    this.localfliterParams.market = item;
    const params = {filter: '', page: 0, perpage: 20};
    if('name' in this.localfliterParams.market) {
      params['market'] = this.localfliterParams.market['id']
    }

    this.sportService.setMarketSpecifiers = this.sportService.loadMarketSpecifiers(params['market']);
    const specifier =  this.sportService.setMarketSpecifiers = this.sportService.loadMarketSpecifiers(params['market']).then(res =>{
      if(res.data.length > 0)
      this.onloadSpecifier.emit(res['data']);
    else this.onloadSpecifier.emit([{ id: 0, name: '0', type: '0', specifier: "0", number: 0 }])
    })

    const data = this.sportService.loadMarketOutcomes(params['market']).then(res =>  {
      this.outcomeChange.emit(res['data']);
    });


  }
  handleGroupsSelection(item, filterData: customSlelect) {
    this.localfliterParams.groups = item;
      const params = {filter: '', page: 0, perpage: 20};
      const [el] = this.selectFilters.filter( el =>  el.type === 'group' );
      if (this.localfliterParams.groups.hasOwnProperty('name')) {
        params['group'] = this.localfliterParams.groups['id'];
      }
      if (el) {
        el.loading = true;
        this.sportService.filterGroups(params).then(response => {
          el.data = this.sportService.groups.data
          el.loading = false;
        });
        if(item && item.id){
          if (item.hasOwnProperty(filterData.selectKey))
            this.searchdata[filterData.selectKey] = item[filterData.selectKey][filterData.itemKey];
          else
            this.searchdata[filterData.selectKey] = item[filterData.itemKey];

          if (item.id.toString().includes('sr:sport')) {
            this.localfliterParams.sport = item;
            const params = {filter: '', page: 0, perpage: 20};
            const [el] = this.selectFilters.filter( el => el.type === 'category');

            if (this.localfliterParams.sport.hasOwnProperty('name')){
              params['sport'] = this.localfliterParams.sport['name'];
            }
            if (el) {
              el.loading = true;
              this.sportService.filterCategories(params).then(response => {
                el.data = this.sportService.categories.data;
                el.loading = false;
              });
            }
          } else if (item.id.toString().includes('sr:category')) {
            this.localfliterParams.category = item;
            const params = {filter: '', page: 0, perpage: 20};
            const [el] = this.selectFilters.filter( el =>  el.type === 'tournament' );
            if (this.localfliterParams.sport.hasOwnProperty('name')) {
              params['sport'] = this.localfliterParams.sport['name'];
            }
            if (this.localfliterParams.category.hasOwnProperty('name')) {
              params['category'] = this.localfliterParams.category['name'];
            }
            if (el) {
              el.loading = true;
              this.sportService.searchTournaments(params).then(response => {
                el.data = this.sportService.tournaments;
                el.loading = false;
              });
            }
          }

          else{
            this.localfliterParams.groups = item;
            const params = {filter: '', page: 0, perpage: 20};
            const [el] = this.selectFilters.filter( el =>  el.type === 'group' );
            if (this.localfliterParams.groups.hasOwnProperty('name')) {
              params['group'] = this.localfliterParams.groups['id'];
            }
            if (el) {
              el.loading = true;
              this.sportService.filterGroups(params).then(response => {
                el.data = this.sportService.groups.data
                el.loading = false;
              });
            }
          }
        }
      }
  }
  filterData(selectfilter: customSlelect, searchdata, type) {
    searchdata.page = 0;
    clearTimeout(this.searchTimeout)
    this.searchTimeout = setTimeout(() => {
      switch (type) {
        case "sport":
          this.sportService.searchSports(searchdata).then(response => {
            selectfilter.data = this.sportService.sports;
          });
          break;
        case "market":
          this.sportService.loadMarkets(searchdata).then(response => {
            selectfilter.data = this.sportService.markets.data;
          });
          break;
        case "group":
          this.sportService.filterGroups(searchdata).then(response => {
            selectfilter.data = this.sportService.groups.data;
          });
          break;
        case "tournament":
          if ( 'name' in this.localfliterParams.sport) {
            searchdata.sport = this.localfliterParams.sport['name'];
          }
          if ('name' in this.localfliterParams.category) {
            searchdata.category = this.localfliterParams.sport['name'];
          }
          selectfilter.loading =  true;
          this.sportService.searchTournaments(searchdata).then(response => {
            selectfilter.data = this.sportService.tournaments;
            selectfilter.loading = false;
          });
          break;
        case "category":
          if ('name' in this.localfliterParams.sport ) {
            searchdata.sport = this.localfliterParams.sport['name'];
          }
          selectfilter.loading = true;
          this.sportService.filterCategories(searchdata).then(response => {
            selectfilter.data = this.sportService.categories.data;
            selectfilter.loading = false;
          });
          break;
        case "event":
          selectfilter.loading = true;
          this.sportService.loadEvents(searchdata).then(response => {
            selectfilter.data = this.sportService.sportEvents;
            selectfilter.loading = false;
          });
          break;

        default:
          break;
      }
    }, 750);
  }

  refreshCustomSelect(selectfilter: customSlelect, type) {
    if (type === 'sport') {
      selectfilter.isRefreshing = true;
      this.localfliterParams.sport = {};
      this.sportService.searchSports({filter: '', page: 0, perpage: 20}).then(_ => {
        selectfilter.data = this.sportService.sports;
        selectfilter.isRefreshing = false;
      });
    }
     else  if (type === 'group') {
        selectfilter.isRefreshing = true;
        this.localfliterParams.groups = {};
        this.sportService.filterGroups(this.searchdata).then(_ => {
          selectfilter.data = this.sportService.groups.data;
        }).finally(() => {
          selectfilter.loading = false;
          selectfilter.isRefreshing = false;
        });;
     }
     else if (type  === 'tournament') {
      selectfilter.isRefreshing = true;
      this.sportService.searchTournaments(this.searchdata).then(_ => {
        selectfilter.data = this.sportService.tournaments;
      }).finally(() => {
        selectfilter.loading = false;
        selectfilter.isRefreshing = false;
      });
    } else if (type  === 'category') {
      selectfilter.isRefreshing = true;
      this.localfliterParams.category = {};
      this.sportService.filterCategories(this.searchdata).then(_ => {
        selectfilter.data = this.sportService.categories.data;
      }).finally(() => {
        selectfilter.loading = false;
        selectfilter.isRefreshing = false;
      });
      this.sportService.filterGroups({filter: '', page: 0, perpage: 20}).then(_ => {
        selectfilter.data = this.sportService.groups.data;
      });
     } else if (type  === 'tournament') {
      selectfilter.isRefreshing = true;
      this.sportService.searchTournaments({filter: '', page: 0, perpage: 20}).then(_ => {
        selectfilter.data = this.sportService.tournaments;
        selectfilter.isRefreshing = false;
      });
    } else if (type  === 'event') {
      selectfilter.isRefreshing = true;
      this.sportService.loadEvents({filter: '', page: 0, perpage: 20}).then(_ => {
        selectfilter.data = this.sportService.sportEvents;
        selectfilter.isRefreshing = false;
      });

    }
    else if (type  === 'product_type') {
      selectfilter.isRefreshing = true;
      this.localfliterParams.productType = {};
      this.partnerService.loadProductTypes({name: '', page: 0, perpage: 20}).then(_ => {
        selectfilter.data = this.partnerService.productTypes;
        selectfilter.isRefreshing = false;
      });
    }
    else if (type  === 'product_group') {
      selectfilter.isRefreshing = true;
      this.localfliterParams.productGroup = {};
      this.partnerService.loadProductGroups({name: '', page: 0, perpage: 20}).then(_ => {
        selectfilter.data = this.partnerService.productGroups;
        selectfilter.isRefreshing = false;
      });
    }
  }
  loadMore(selectfilter: customSlelect, searchdata, type) {
    selectfilter.loading = true;
  switch (type) {
    case 'sport':
      this.sportService.searchSports(searchdata, 'load-more').then( _ => {
        selectfilter.data = this.sportService.sports;
      }).finally(() => {
        selectfilter.loading = false;
      });
    break;
    case 'group':
      this.sportService.filterGroups(searchdata, 'load-more').then( _ => {
        selectfilter.data = this.sportService.groups.data;
      }).finally(() => {
        selectfilter.loading = false;
      });
    break;
    case 'tournament':
      if (this.localfliterParams.sport.hasOwnProperty('name')) {
        searchdata.sport = this.localfliterParams.sport['name'];
      }
      if (this.localfliterParams.category.hasOwnProperty('name')) {
        searchdata.category = this.localfliterParams.sport['name'];
      }
      this.sportService.searchTournaments(searchdata, 'load-more').then(response => {
        selectfilter.data = this.sportService.tournaments;
      }).finally(() => {
        selectfilter.loading = false;
      });
    break;

    case 'category':
      if (this.localfliterParams.sport.hasOwnProperty('name')) {
        searchdata.sport = this.localfliterParams.sport['name'];
      }
      this.sportService.filterCategories(searchdata, 'load-more').then(response => {
        selectfilter.data = this.sportService.categories.data;
      }).finally(() => {
        selectfilter.loading = false;
      });
    break;

    case 'product_type':
      this.partnerService.loadProductTypes(searchdata, 'load-more').then( _ => {
        selectfilter.data = this.partnerService.productTypes;
      }).finally(() => {
        selectfilter.loading = false;
      });
    break;

    case 'product_group':
      this.partnerService.loadProductGroups(searchdata, 'load-more').then( _ => {
        selectfilter.data = this.partnerService.productGroups;
      }).finally(() => {
        selectfilter.loading = false;
      });
    break;

    case 'market':
      this.sportService.loadMarkets(searchdata, 'load-more').then(_ => {
        selectfilter.data = this.sportService.markets.data;
      }).finally(()=> {
        selectfilter.loading = false;
      });
    break;
    case 'event':
      this.sportService.loadEvents(searchdata, 'load-more').then(_ => {
        selectfilter.data = this.sportService.sportEvents;
      }).finally(()=> {
        selectfilter.loading = false;
      });
    break;
    default:
      break;
    }
  }
  EnterSubmit(event){
    if (event.keyCode === 13)
    this.submit();
  }

  onLanguageChange(value: string) {
    if (this.languageFilter) {
      this.searchdata[this.languageFilter.action] = value || undefined;
      this.languageFilterChange.emit(value);
    }
  }

  getFlagUrl(langCode: string): string {
    return this.flagService.getFlagUrlWithSize(langCode, 16);
  }

  onActionClicked(action: (param?: any) => void) {
      if (action) {
        action(this.tableInstance);
      }
  }
  ngOnDestroy(){
    this.goalSearch = false;
    if(this.searchTimeout) clearTimeout(this.searchTimeout);
    if(this.refreshTimeout) clearTimeout(this.refreshTimeout);
  }
}
